import React, { memo, useEffect, useState } from 'react';
import { ToastMessage, Typography, logUserEvent } from 'fmc-digital-common';
import { useLipStore } from '../../../reducers';
import { VStack, Stack } from 'native-base';
import { Platform } from 'react-native';
const LIPToastMessage = /*#__PURE__*/memo(() => {
  const {
    toastMessageProps: toastMessages,
    setShowDocUploadModal,
    setShowDocUploadModalWeb,
    clearToastMessageProps,
    uploadedFiles,
    clearSelectedFiles,
    setSelectedFiles,
    clearUploadedFiles,
    toastmessageEsign
  } = useLipStore(state => state);
  const [failedFiles, setFailedFiles] = useState([]);
  const {
    isShowToastMessage: isShowEsignToastMessage
  } = toastmessageEsign;
  const onHandleToastMessage = toastMessage => {
    clearSelectedFiles();
    if (toastMessage?.toastType === 'SUCCESS') {
      logUserEvent({
        action: 'UploadMoreClicked',
        type: 'LIPDocUploadSuccessToast',
        description: 'Task Section Doc Upload Task ' + toastMessage.trackingItemName
      });
    } else {
      logUserEvent({
        action: 'TryAgainClicked',
        type: 'LIPDocUploadFailureToast',
        description: 'Task Section Doc Upload Task ' + toastMessage.trackingItemName
      });
      setSelectedFiles(failedFiles);
    }
    clearToastMessageProps();
    clearUploadedFiles();
    if (toastMessage?.type === 'docUploadMessage') {
      setShowDocUploadModal(true);
      setShowDocUploadModalWeb(true);
    }
  };
  useEffect(() => {
    if (uploadedFiles?.length > 0) {
      const failedUploads = uploadedFiles.filter(item => !item?.isSuccess);
      setFailedFiles(failedUploads);
    }
  }, [uploadedFiles]);
  const getToastSection = toastMessage => /*#__PURE__*/React.createElement(ToastMessage, {
    icon: toastMessage?.toastType === 'SUCCESS' ? 'check-circle' : 'error',
    buttonText: toastMessage?.buttonText,
    iconProps: {
      name: toastMessage?.toastType === 'SUCCESS' ? 'check-circle' : 'error',
      color: 'white.500',
      size: 22
    },
    onClick: () => onHandleToastMessage(toastMessage),
    bgColor: toastMessage?.toastType === 'SUCCESS' ? 'success.300' : 'error.300',
    bodyText: toastMessage?.bodyText
  }, /*#__PURE__*/React.createElement(Stack, {
    flex: '1'
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: toastMessage?.bodyText ? 'regularBold' : 'caption13',
    color: 'white.500',
    flexWrap: 'wrap'
  }, `${toastMessage?.message}`), toastMessage?.type === 'docUploadMessage' && toastMessage?.toastType === 'ERROR' ? /*#__PURE__*/React.createElement(Stack, null, failedFiles.map((item, index) => /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption13',
    numberOfLines: 1,
    color: 'white.500'
  }, `${item.name}`, failedFiles.length - 2 === index ? ' and' : failedFiles.length - 1 !== index ? ', ' : '.')), /*#__PURE__*/React.createElement(Typography, {
    variant: 'caption13',
    color: 'white.500'
  }, 'Please try again.')) : null));
  return /*#__PURE__*/React.createElement(React.Fragment, null, toastMessages?.length > 0 ? /*#__PURE__*/React.createElement(VStack, {
    space: "2",
    position: 'fixed',
    bottom: '5',
    width: {
      base: '100%',
      sm: '100%',
      md: '40%',
      lg: '25%',
      xl: '25%'
    },
    maxW: Platform.OS === 'web' ? '85%' : '100%'
  }, toastMessages.map(toast => getToastSection(toast))) : isShowEsignToastMessage ? /*#__PURE__*/React.createElement(VStack, {
    space: "2",
    position: 'fixed',
    bottom: '5',
    width: {
      base: '100%',
      sm: '100%',
      md: '40%',
      lg: '25%',
      xl: '25%'
    },
    maxW: Platform.OS === 'web' ? '85%' : '100%'
  }, getToastSection(toastmessageEsign)) : null);
});
export default LIPToastMessage;
//# sourceMappingURL=index.js.map